import { CircularProgress, Stack, Typography } from "@mui/material";
import Popup from "../../../../Common/components/Popup/Popup";
import { orderTools } from "../../../../Common/utils/toolUtil";
import Package from "../../components/Package/Package";
import useSelectPackage from "../../hooks/useSelectPackage";
import styles from "./SelectPackage.module.scss";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

interface SelectPackageProps {
  setActiveStep: (step: number) => void;
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  backgroundColor: "rgba(255, 255, 255, .05)",
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  padding: "0px",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const SelectPackageStep = ({
  setActiveStep,
}: SelectPackageProps): JSX.Element => {
  const {
    packagesGrouped,
    isLoading,
    onMoreInfoClickHandler,
    isPopupOpen,
    closePopupHandler: handleClosePopup,
    popupContent,
    popupTitle,
    selectPackageHandler,
  } = useSelectPackage(setActiveStep);

  return (
    <>
      {isLoading && (
        <Stack alignItems="center">
          <CircularProgress />
        </Stack>
      )}
      {!isLoading &&
        packagesGrouped.map(({ packageCategory, packages }) => (
          <Accordion defaultExpanded key={packageCategory.id}>
            <AccordionSummary>
              <Typography variant="h6">{packageCategory.name}</Typography>
            </AccordionSummary>
            <MuiAccordionDetails>
              <Typography variant={"body2"} sx={{ marginBottom: 2 }}>
                {packageCategory.description}
              </Typography>
              <Popup
                open={isPopupOpen}
                handleClose={handleClosePopup}
                content={popupContent}
                title={popupTitle}
              />

              <div className={styles.packages}>
                {packages.map((p, i) => (
                  <Package
                    selectPackageHandler={() => selectPackageHandler(p)}
                    key={i}
                    name={p.name}
                    description={p.description}
                    moreInfo={p.description}
                    tools={orderTools(p.tools)}
                    optionalTools={orderTools(p.optionalTools)}
                    onMoreInfoClick={() => onMoreInfoClickHandler(p)}
                    customIcons={p.CustomIcons}
                  />
                ))}
              </div>
            </MuiAccordionDetails>
          </Accordion>
        ))}
    </>
  );
};

export default SelectPackageStep;
